import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/returns.scss";

function Returns() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="returns">
      <div className="returns__shell">
        <nav className="returns__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">Returns</span>
        </nav>

        <header className="returns__header">
          <p className="returns__kicker">Customer care</p>
          <h1>Returns &amp; refunds</h1>
          <p>Changed your mind? This Germany-based store explains the EU withdrawal process and other applicable rights below.</p>
        </header>

        <section className="returns__window" aria-labelledby="returns-window-title">
          <p className="returns__window-number" aria-hidden="true">14</p>
          <div>
            <p className="returns__eyebrow">Calendar days</p>
            <h2 id="returns-window-title">Where EU withdrawal rules apply, tell us within 14 days of receiving your order.</h2>
            <p>
              You do not need to give a reason. After notifying us, return eligible goods within a further 14 days.
              Rights available outside the EU may differ, and statutory rights for faulty or misdescribed items are not affected.
            </p>
          </div>
        </section>

        <section className="returns__section" aria-labelledby="returns-steps-title">
          <div className="returns__section-heading">
            <p className="returns__eyebrow">The process</p>
            <h2 id="returns-steps-title">Three steps to request a return</h2>
          </div>
          <ol className="returns__steps">
            <li>
              <span>01</span>
              <h3>Contact us</h3>
              <p>Email {siteConfig.contact.email} or use the contact form with the order number and item name.</p>
            </li>
            <li>
              <span>02</span>
              <h3>Pack with care</h3>
              <p>Keep the item unused, complete and in its original product packaging wherever reasonable.</p>
            </li>
            <li>
              <span>03</span>
              <h3>Keep your receipt</h3>
              <p>Use a suitable postal service and retain proof of postage until the return is resolved.</p>
            </li>
          </ol>
        </section>

        <div className="returns__columns">
          <section className="returns__panel" aria-labelledby="returns-condition-title">
            <p className="returns__eyebrow">Return condition</p>
            <h2 id="returns-condition-title">What can come back</h2>
            <ul>
              <li>Unused items handled only as needed to inspect their nature and features.</li>
              <li>All supplied parts, accessories and promotional items.</li>
              <li>Original retail packaging in a resalable condition where possible.</li>
            </ul>
            <p>
              A deduction may apply if handling goes beyond what would reasonably be allowed in a shop and
              reduces the product&apos;s value.
            </p>
          </section>

          <section className="returns__panel returns__panel--warning" aria-labelledby="returns-exceptions-title">
            <p className="returns__eyebrow">Important exceptions</p>
            <h2 id="returns-exceptions-title">Personalised goods</h2>
            <p>
              Made-to-order or personalised products—including engraved pens—cannot normally be returned
              because you changed your mind once production has started.
            </p>
            <p>
              This exception does not remove your rights when a personalised item is faulty, damaged or not
              as described. Sealed goods may also be excluded where opening them creates a health, hygiene or
              software-licensing issue.
            </p>
          </section>
        </div>

        <section className="returns__section returns__section--bordered" aria-labelledby="returns-refund-title">
          <div className="returns__section-heading">
            <p className="returns__eyebrow">After arrival</p>
            <h2 id="returns-refund-title">Refunds and return costs</h2>
          </div>
          <div className="returns__prose">
            <p>
              Where EU withdrawal rules apply, reimbursement is initiated within 14 days after notice of withdrawal
              and may be withheld until the goods arrive or you provide evidence that they were sent back. The refund
              includes the item price and the cost of the least expensive standard outbound delivery offered for the order.
            </p>
            <p>
              Change-of-mind return postage is normally paid by the customer. If an item is faulty, damaged or
              incorrect, contact us before sending it so an appropriate return route can be arranged. Refund posting
              time after initiation can vary by payment provider.
            </p>
          </div>
        </section>

        <aside className="returns__demo-note">
          <strong>Before sending an item:</strong> contact us for return instructions and the correct destination.
          Do not send a return to the business address at {siteConfig.contact.address} unless customer service confirms
          it as the return destination. Returns sent without an order reference can take longer to identify and process.
        </aside>

        <section className="returns__support" aria-labelledby="returns-support-title">
          <div>
            <p className="returns__eyebrow">Ready to start?</p>
            <h2 id="returns-support-title">Tell us what you would like to return.</h2>
          </div>
          <Link className="returns__button" to="/contact" onClick={toTop}>
            Start a return <span aria-hidden="true">→</span>
          </Link>
        </section>
      </div>
    </main>
  );
}

export default Returns;
